/* global gsap, ScrollTrigger */
if (window.innerWidth > 991) {
    gsap.registerPlugin(ScrollTrigger);

    function initAccordionAnimation() {
        document.querySelectorAll('.ecosystems-showcase').forEach(section => {
            const titles = section.querySelectorAll('.es-title');
            const headings = section.querySelectorAll('.es-heading');
            const images = section.querySelectorAll('.es-image-inner');

            if (!titles.length || !headings.length || !images.length) { return; }

            headings.forEach((h, i) => {
                gsap.set(h, {
                    opacity: i === 0 ? 1 : 0,
                    y: 0,
                });
            });
            images.forEach((img, i) => {
                gsap.set(img, {
                    opacity: i === 0 ? 1 : 0,
                    scale: 1,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                });
            });

            let currentIndex = 0;

            if (titles.length === 1) {
                activate(0);
                return;
            }

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'top top',
                    end: '+=300%',
                    pin: true,
                    scrub: true,
                    onUpdate(self) {
                        const p = self.progress || 0;
                        const idx = Math.min(titles.length - 1, Math.floor(p * titles.length));
                        if (currentIndex !== idx) {
                            activate(idx);
                            currentIndex = idx;
                        }
                    },
                    onRefresh(self) {
                        activate(0);
                        currentIndex = 0;
                    },
                },
            });

            titles.forEach(title => {
                const progress = title.querySelector('.progress');
                tl.to(progress, { width: '100%', duration: 1, ease: 'none' })
                    .to(progress, { width: '0%', duration: 0.01, ease: 'none' });
            });

            activate(0);
            currentIndex = 0;

            function activate(index) {
                const wrap = section.querySelector('.es-top-wrap');
                const currentHeading = headings[index];

                headings.forEach((h, i) => {
                    gsap.fromTo(h, {
                        opacity: 0,
                        y: '50%',
                    }, {
                        opacity: i === index ? 1 : 0,
                        y: 0,
                        duration: 0.5,
                        ease: 'power2.out',
                    });
                    h.classList.toggle('active', i === index);
                });

                images.forEach((img, i) => {
                    const isActive = parseInt(img.getAttribute('data-id'), 10) === index + 1;
                    gsap.to(img, {
                        opacity: isActive ? 1 : 0,
                        scale: isActive ? 1 : 0.95,
                        duration: 0.5,
                        ease: 'power2.out',
                    });
                    img.classList.toggle('active', isActive);
                });

                if (wrap && currentHeading) {
                    gsap.to(wrap, {
                        height: currentHeading.offsetHeight,
                        duration: 0.4,
                        ease: 'power2.out',
                    });
                }

                titles.forEach((t, i) => {
                    t.classList.toggle('active', i === index);
                });

                const counterEl = section.querySelector('.current-count');
                if (counterEl) {
                    counterEl.textContent = String(index + 1).padStart(2, '0');
                }
            }
        });
    }

    initAccordionAnimation();

    window.addEventListener('resize', () => {
        if (window.innerWidth > 767) {
            ScrollTrigger.getAll().forEach(st => st.kill());
            initAccordionAnimation();
        }
    });
}